export default __webpack_public_path__ + "static/media/Erinr-Eli5DAO.7caf6ce5.jpg";